<template>
  <div class="dashboard-widget">
    <h6 class="text-primary">Latest Bookings</h6>
    <router-link
      v-for="booking in bookings"
      :key="booking.id"
      :to="{ name: 'Booking Profile', params: { id: booking.id } }"
      tag="div"
      class="booking-item md-layout"
    >
      <div class="md-layout-item md-size-80 tour">
        <h6>
          {{ booking.departure.tour }} | {{ booking.departure.start_date }}
        </h6>
      </div>
      <div class="md-layout-item md-size-20 booking-id text-right">
        <h6>#{{ booking.id }}</h6>
      </div>

      <div class="md-layout-item md-size-60 lead-booker">
        {{ booking.lead_booker.full_name }}
      </div>
      <div class="md-layout-item md-size-40 value text-right">
        {{ booking.currency.toUpperCase() }}
        {{ booking.financials.booking_total }}
      </div>
      <div class="md-layout-item md-size-60 booking-date">
        <div class="md-caption">
          Booked: {{ booking.booking_date | formatDateTime }}
        </div>
      </div>
      <div class="md-layout-item md-size-40 value text-right">
        <div class="md-caption">
          {{ booking.financials.status.description }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";

export default {
  name: "WidgetNewBookings",
  data() {
    return {
      bookings: []
    };
  },

  computed: {},

  methods: {},

  created() {
    bookingApi.getNewBookings().then(response => {
      this.bookings = response.data.bookings;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.tour h6,
.booking-id h6 {
  margin: 0;
}

.booking h6 {
  margin: 0;
}
p {
  margin: 0;
}
.booking-item {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}
.actions {
  .action-button {
    width: 24px;
    min-width: 24px;
    height: 24px;
    margin: 0px;
  }
}
</style>
